module.exports = "/images/body-front.svg?8e19d77a53856e25c5cf311f038c8e0e";